module.exports = __webpack_public_path__ + "static/media/DuplicateSans-MediumItalic.4aa8336b.woff2";